/**
 * formatExplanation.js
 * 
 * Adds line breaks at logical points in explanation text so it renders
 * as readable paragraphs instead of a wall of text.
 * 
 * Works with whiteSpace: 'pre-wrap' in the React component.
 * Text that already has real newlines passes through unchanged.
 * 
 * Place this file alongside ExamInterface.jsx and import:
 *   import { formatExplanation } from './formatExplanation';
 */

export function formatExplanation(text) {
  if (!text) return '';

  // If text already has 3+ real newlines, it's already formatted — pass through
  const realNewlines = (text.match(/\n/g) || []).length;
  if (realNewlines >= 3) return text;

  let result = text;

  // 1. Break before numbered sections: ". (1)", ". (2)", etc.
  result = result.replace(/\.\s*\((\d+)\)\s*/g, '.\n\n($1) ');

  // 2. Break before individual "Option X is correct/wrong" verdicts
  result = result.replace(/\.\s+(Option [A-E] is (?:correct|wrong|WRONG))/g, '.\n$1');

  // 3. Break before "Correct:" and "Wrong:" summary lines
  result = result.replace(/\.\s+(Correct:)/g, '.\n\n$1');
  result = result.replace(/\.\s+(Wrong:)/g, '.\n$1');

  // 4. Break before "Applied here:"
  result = result.replace(/\.\s+(Applied here:)/g, '.\n\n$1');

  // 5. Break before "Options A, B, C are correct" group references
  result = result.replace(/\.\s+(Options? [A-E])/g, '.\n\n$1');

  // 6. Clean up any triple+ newlines to double
  result = result.replace(/\n{3,}/g, '\n\n');

  return result.trim();
}